import React, { useState } from 'react'

import { Box, Button, TextField, Typography } from '@material-ui/core'
import { Link as LinkIcon } from 'react-feather'

import useFetch from 'hooks/useFetch'
import useSnackbar from 'hooks/useSnackbar'
import * as service from 'service'
import courseConstants from 'constants/courseAccess'
import useStyles from './styles'

const { ACCESS_TYPES } = courseConstants

const PublicLinkBanner = ({ courseId }) => {
  const classes = useStyles()
  const snackbar = useSnackbar()
  const [copied, setCopied] = useState(false)

  const { response: configResponse } = useFetch(
    service.dponet.trainingCourse.courseCompanyConfig,
    { courseId },
    [courseId],
  )

  const { response: courseResponse } = useFetch(
    service.dponet.trainingCourse.show,
    { courseId },
    [courseId],
  )

  const { response: portalResponse } = useFetch(
    service.dponet.trainingCourse.portalLink,
    {},
    [],
  )

  const accessType = configResponse?.data?.courseCompanyConfig?.accessType
  const publicToken = courseResponse?.data?.course?.publicToken
  const portalToken = portalResponse?.data?.companyAccessLink?.token

  if (accessType !== ACCESS_TYPES.PUBLIC_LINK || !publicToken || !portalToken) {
    return null
  }

  const inviteLink = `${window.location.origin}/training/${portalToken}/invite_course/${publicToken}`

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteLink).then(() => {
      setCopied(true)
      snackbar.open({ message: 'Link copiado!', variant: 'success' })
      setTimeout(() => setCopied(false), 2000)
    })
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <LinkIcon className={classes.icon} />
        <Typography className={classes.label}>Link de Autocadastro</Typography>
      </Box>
      <Typography className={classes.description}>
        Compartilhe o link abaixo para que qualquer pessoa possa se matricular
        neste curso sem a intervenção de um gestor.
      </Typography>
      <Box className={classes.linkRow}>
        <TextField
          variant="outlined"
          value={inviteLink}
          className={classes.linkInput}
          inputProps={{ readOnly: true }}
          size="small"
        />
        <Button
          variant="contained"
          color="primary"
          size="small"
          className={classes.copyButton}
          onClick={handleCopy}
        >
          {copied ? 'Copiado!' : 'Copiar link'}
        </Button>
      </Box>
    </Box>
  )
}

export default PublicLinkBanner
